<div class="others-message__container">
  <p class="others-message__paragraph" [innerHtml]="messageText | formatTextWithLinks"></p>
</div>
